// Static demonstration data for frontend design only.
// All prices, stock quantities, and EU ratings are illustrative.

const products = [
  {
    id: 1,
    brand: "Michelin",
    name: "Primacy 4+",
    size: "205/55 R16",
    width: 205,
    height: 55,
    diameter: 16,
    load_index: "91",
    speed_index: "V",
    season: "summer",
    image: "/assets/images/products/michelin.png",
    price: 94.90,
    currency: "EUR",
    stock: 24,
    runflat: false,
    eu: { fuel: "B", wet: "A", noise: 69 },
  },
  {
    id: 2,
    brand: "Continental",
    name: "PremiumContact 7",
    size: "225/45 R17",
    width: 225,
    height: 45,
    diameter: 17,
    load_index: "94",
    speed_index: "Y",
    season: "summer",
    image: "/assets/images/products/continental.png",
    price: 109.90,
    currency: "EUR",
    stock: 18,
    runflat: false,
    eu: { fuel: "C", wet: "A", noise: 71 },
  },
  {
    id: 3,
    brand: "Pirelli",
    name: "Cinturato P7",
    size: "205/55 R16",
    width: 205,
    height: 55,
    diameter: 16,
    load_index: "91",
    speed_index: "V",
    season: "summer",
    image: "/assets/images/products/pirelli.png",
    price: 87.50,
    currency: "EUR",
    stock: 12,
    runflat: false,
    eu: { fuel: "B", wet: "B", noise: 70 },
  },
  {
    id: 4,
    brand: "Goodyear",
    name: "Vector 4Seasons Gen-3",
    size: "205/55 R16",
    width: 205,
    height: 55,
    diameter: 16,
    load_index: "94",
    speed_index: "V",
    season: "all-season",
    image: "/assets/images/products/goodyear.png",
    price: 98.90,
    currency: "EUR",
    stock: 16,
    runflat: false,
    eu: { fuel: "C", wet: "B", noise: 70 },
  },
  {
    id: 5,
    brand: "Hankook",
    name: "Ventus Prime 4",
    size: "225/45 R17",
    width: 225,
    height: 45,
    diameter: 17,
    load_index: "91",
    speed_index: "W",
    season: "summer",
    image: "/assets/images/products/hankook.png",
    price: 76.90,
    currency: "EUR",
    stock: 30,
    runflat: false,
    eu: { fuel: "B", wet: "A", noise: 69 },
  },
  {
    id: 6,
    brand: "Bridgestone",
    name: "Turanza 6",
    size: "225/40 R18",
    width: 225,
    height: 40,
    diameter: 18,
    load_index: "92",
    speed_index: "Y",
    season: "summer",
    image: "/assets/images/products/bridgestone.png",
    price: 119.90,
    currency: "EUR",
    stock: 9,
    runflat: false,
    eu: { fuel: "B", wet: "A", noise: 70 },
  },
  {
    id: 7,
    brand: "Dunlop",
    name: "Sport BluResponse",
    size: "195/65 R15",
    width: 195,
    height: 65,
    diameter: 15,
    load_index: "91",
    speed_index: "H",
    season: "summer",
    image: "/assets/images/products/dunlop.png",
    price: 69.90,
    currency: "EUR",
    stock: 14,
    runflat: false,
    eu: { fuel: "B", wet: "B", noise: 68 },
  },
  {
    id: 8,
    brand: "Nexen",
    name: "N'Blue 4Season",
    size: "205/55 R16",
    width: 205,
    height: 55,
    diameter: 16,
    load_index: "91",
    speed_index: "H",
    season: "all-season",
    image: "/assets/images/products/nexen.png",
    price: 62.90,
    currency: "EUR",
    stock: 21,
    runflat: false,
    eu: { fuel: "C", wet: "B", noise: 72 },
  },
  {
    id: 9,
    brand: "Michelin",
    name: "Alpin 7",
    size: "205/55 R16",
    width: 205,
    height: 55,
    diameter: 16,
    load_index: "91",
    speed_index: "H",
    season: "winter",
    image: "/assets/images/products/michelin.png",
    price: 112.90,
    currency: "EUR",
    stock: 8,
    runflat: false,
    eu: { fuel: "C", wet: "B", noise: 71 },
  },
  {
    id: 10,
    brand: "Kumho",
    name: "Ecsta PS71",
    size: "225/45 R17",
    width: 225,
    height: 45,
    diameter: 17,
    load_index: "94",
    speed_index: "Y",
    season: "summer",
    image: "/assets/images/products/kumho.png",
    price: 71.50,
    currency: "EUR",
    stock: 0,
    runflat: false,
    eu: { fuel: "C", wet: "A", noise: 72 },
  },
  {
    id: 11,
    brand: "Continental",
    name: "AllSeasonContact 2",
    size: "225/45 R17",
    width: 225,
    height: 45,
    diameter: 17,
    load_index: "94",
    speed_index: "V",
    season: "all-season",
    image: "/assets/images/products/continental.png",
    price: 115.90,
    currency: "EUR",
    stock: 10,
    runflat: false,
    eu: { fuel: "B", wet: "B", noise: 70 },
  },
  {
    id: 12,
    brand: "Pirelli",
    name: "Winter Sottozero 3",
    size: "225/40 R18",
    width: 225,
    height: 40,
    diameter: 18,
    load_index: "92",
    speed_index: "V",
    season: "winter",
    image: "/assets/images/products/pirelli.png",
    price: 139.90,
    currency: "EUR",
    stock: 6,
    runflat: false,
    eu: { fuel: "C", wet: "B", noise: 72 },
  },
];

export default products;